<mat-sidenav-container>
  <mat-sidenav
    #sidenav
    mode="over"
    position="end"
    (closed)="closeNotification()"
    [ngClass]="{ weather: sidenavPage === 'weather' }"
  >
    <app-login [sidenav]="this" *ngIf="sidenavPage === 'login'"></app-login>
    <app-register
      [sidenav]="this"
      *ngIf="sidenavPage === 'register'"
    ></app-register>
    <app-contact-us
      [sidenav]="this"
      *ngIf="sidenavPage === 'contact'"
    ></app-contact-us>
    <app-weather
      [sidenav]="this"
      *ngIf="sidenavPage === 'weather'"
    ></app-weather>
    <app-settings
      [sidenav]="this"
      *ngIf="sidenavPage === 'settings'"
    ></app-settings>
    <app-mfa [sidenav]="this" *ngIf="sidenavPage === 'mfa'"></app-mfa>
    <app-download-handbook
      [changeStatus]="changeStatus"
      [data]="downloadHandbookData"
      [sidenav]="this"
      *ngIf="sidenavPage === 'download-handbooks'"
    ></app-download-handbook>
  </mat-sidenav>
  <mat-sidenav-content>
    <app-header
      #header
      (onLogin)="openSidenav('login')"
      (onRequestPda)="openSidenav('contact')"
      (onWeather)="openSidenav('weather')"
      (onSettings)="openSidenav('settings')"
    ></app-header>
    <ng-content></ng-content>
  </mat-sidenav-content>
</mat-sidenav-container>
